import React from 'react';

const ICON_ID = 'icon-info-blue';

const IconInfoBlue = function(props) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Info Blue Icon</title>
      <g fill="none" fillRule="evenodd">
        <path d="M12.5 0C5.597 0 0 5.595 0 12.497s5.597 12.498 12.5 12.498S25 19.4 25 12.497C25 5.595 19.403 0 12.5 0m0 1.024c6.327 0 11.476 5.147 11.476 11.473 0 6.326-5.149 11.472-11.476 11.472-6.327 0-11.476-5.146-11.476-11.472S6.173 1.024 12.5 1.024l-35.214-2.037" fill="#00A1E1"/>
        <path d="M12.5 19.718V8.828M12.5 7.675V5.49" stroke="#161616" strokeWidth="1.537"/>
      </g>
    </svg>
  );
}

export default IconInfoBlue;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-info-blue.jsx